import { RateBlockFieldNames, RateBlockKey } from './rate-block.model';

// All three rate blocks, in the order they should be checked/rendered.
export const RATE_BLOCK_KEYS: RateBlockKey[] = ['standard', 'ot1', 'ot2'];

// Maps each block to its field names on PortTariffLineModel / PortTariffLineFormModel.
export const RATE_BLOCK_FIELD_NAMES: Record<RateBlockKey, RateBlockFieldNames> = {
  standard: {
    rateValue: 'rateValue',
    unitType: 'unitType',
    vesselProperty: 'vesselProperty',
    quantityMultiplier: 'quantityMultiplier',
    cargoType: 'cargoType',
  },
  ot1: {
    rateValue: 'ot1RateValue',
    unitType: 'ot1UnitType',
    vesselProperty: 'ot1VesselProperty',
    quantityMultiplier: 'ot1QuantityMultiplier',
    cargoType: 'ot1CargoType',
  },
  ot2: {
    rateValue: 'ot2RateValue',
    unitType: 'ot2UnitType',
    vesselProperty: 'ot2VesselProperty',
    quantityMultiplier: 'ot2QuantityMultiplier',
    cargoType: 'ot2CargoType',
  },
};

// Translation key for each block's display name (used in validation messages).
export const RATE_BLOCK_LABEL_KEYS: Record<RateBlockKey, string> = {
  standard: 'portTariffLines.blocks.standard',
  ot1: 'portTariffLines.blocks.ot1',
  ot2: 'portTariffLines.blocks.ot2',
};
